export const API_KEY = "AIzaSyDTHJVPJwlhctLHId-udfMpCvv3Pe1WuVk";

export default API_KEY;